import { createContext } from "react";
import type { Profile } from "../types/profileTypes";

export interface ProfileContextType {
  profile: Profile | null | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
}

export const ProfileContext = createContext<ProfileContextType | undefined>(
  undefined
);
